import { render, staticRenderFns } from "./FmTableNewDemo.vue?vue&type=template&id=86813684&scoped=true&"
import script from "./FmTableNewDemo.vue?vue&type=script&lang=js&"
export * from "./FmTableNewDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86813684",
  null
  
)

export default component.exports